"use strict";

document.addEventListener('DOMContentLoaded', function () {

    // Fallback for the prototype (DE)
    const splideI18nDefault = {
        prev: 'Vorheriger Slide',
        next: 'Nächster Slide',
        first: 'Erster Slide',
        last: 'Letzter Slide',
        slideX: 'Gehe zu Slide %s',
        pageX: 'Gehe zu Seite %s',
        play: 'Autoplay starten',
        pause: 'Autoplay pausieren',
        carousel: 'Slider',
        slide: 'Slide',
        select: 'Wähle einen Slide zum Anzeigen',
    };

    // Logic for initialization (Merging of defaults and MODX overrides)
    const i18nConfig = Object.assign({}, splideI18nDefault, window.splideL10n || {});



    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide heroSlider
    // *
    // *

    const heroSlider = document.getElementsByClassName('js-hero-slider');

    if (heroSlider !== null) {
        for (let i = 0; i < heroSlider.length; i++) {
            new Splide(heroSlider[i], {
                type: 'fade',
                pauseOnHover: true,
                rewind: true,
                lazyLoad: 'nearby',
                i18n: i18nConfig
            }).mount();
        }
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide textSlider
    // *
    // *

    const textSlider = document.getElementsByClassName('js-text-slider');

    if (textSlider !== null) {
        for (let i = 0; i < textSlider.length; i++) {
            new Splide(textSlider[i], {
                type: 'slide',
                rewind: true,
                arrows: true,
                pagination: true,
                lazyLoad: 'nearby',
                perPage: 1,
                gap: '3rem',
                i18n: i18nConfig,
                breakpoints: {
                    768: {
                        perPage: 1,
                    }
                }
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide teaserSlider
    // *
    // *

    const teaserSlider = document.getElementsByClassName('js-teaser-slider');

    if (teaserSlider !== null) {
        for (let i = 0; i < teaserSlider.length; i++) {
            const slideCount = teaserSlider[i].querySelectorAll('.splide__slide').length;
            const hasPeek = slideCount > 3;
            if (hasPeek) teaserSlider[i].classList.add('has-peek');

            const splide = new Splide(teaserSlider[i], {
                type: 'slide',
                rewind: true,
                perPage: 3,
                perMove: 1,
                gap: '50px',
                padding: { left: 0, right: hasPeek ? '8%' : 0 },
                arrows: true,
                pagination: false,
                lazyLoad: 'nearby',
                i18n: i18nConfig,
                breakpoints: {
                    960: {
                        perPage: 2,
                        gap: '30px',
                        padding: { left: 0, right: hasPeek ? '10%' : 0 }
                    },
                    600: {
                        perPage: 1,
                        gap: '20px',
                        padding: { left: 0, right: 0 }
                    }
                }
            }).mount();

            // adaptive height on mobile: match track height to active slide content
            const teaserTrack = teaserSlider[i].querySelector('.splide__track');
            const teaserSlides = Array.from(teaserSlider[i].querySelectorAll('.splide__slide'));
            const mobileQ = window.matchMedia('(max-width: 600px)');

            const updateTeaserHeight = (index) => {
                if (!mobileQ.matches) {
                    if (teaserTrack) teaserTrack.style.height = '';
                    return;
                }
                const slide = teaserSlides[index] || teaserSlides[0];
                if (teaserTrack && slide) teaserTrack.style.height = slide.scrollHeight + 'px';
            };

            if (teaserTrack) teaserTrack.style.transition = 'height 0.3s ease';
            splide.on('mounted', () => setTimeout(() => updateTeaserHeight(0), 50));
            splide.on('move', updateTeaserHeight);
            new ResizeObserver(() => updateTeaserHeight(splide.index)).observe(teaserSlider[i]);
            mobileQ.addEventListener('change', () => updateTeaserHeight(splide.index));

            // page based counter (1 / 2)
            const counter = teaserSlider[i].querySelector('.js-teaser-counter');
            if (counter) {
                const updateCounter = (index) => {
                    const perPage = splide.options.perPage;
                    const totalPages = Math.max(1, Math.ceil((splide.length - perPage) / perPage) + 1);
                    const page = Math.min(Math.ceil(index / perPage) + 1, totalPages);
                    counter.textContent = `${page} / ${totalPages}`;
                };
                updateCounter(0);
                splide.on('moved', updateCounter);
                splide.on('updated', () => updateCounter(splide.index));
            }
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide testimonialSlider
    // *
    // *

    const testimonialSlider = document.getElementsByClassName('js-testimonial-slider');

    if (testimonialSlider !== null) {
        for (let i = 0; i < testimonialSlider.length; i++) {
            const splide = new Splide(testimonialSlider[i], {
                type: 'slide',
                rewind: true,
                arrows: true,
                pagination: false,
                i18n: i18nConfig
            }).mount();

            // Adaptive height: set track to full slide content height
            const track = testimonialSlider[i].querySelector('.splide__track');
            const slides = Array.from(testimonialSlider[i].querySelectorAll('.splide__slide'));

            const updateTrackHeight = (index) => {
                const slide = slides[index] || slides[0];
                if (track && slide) {
                    track.style.height = slide.scrollHeight + 'px';
                }
            };

            if (track) track.style.transition = 'height 0.3s ease';
            splide.on('mounted', () => setTimeout(() => updateTrackHeight(0), 50));
            splide.on('move', updateTrackHeight);

            const ro = new ResizeObserver(() => updateTrackHeight(splide.index));
            ro.observe(testimonialSlider[i]);

            const counter = testimonialSlider[i].querySelector('.js-testimonial-counter');
            if (counter) {
                const total = splide.length;
                counter.textContent = `1 / ${total}`;
                splide.on('moved', (newIndex) => {
                    counter.textContent = `${newIndex + 1} / ${total}`;
                });
            }
        }
    }

    // testimonials parallax: images follow scroll — centered in viewport = final position
    document.querySelectorAll('.testimonials').forEach((module) => {
        const leftEl  = module.querySelector('.testimonials__left');
        const rightEl = module.querySelector('.testimonials__right');
        if (!leftEl && !rightEl) return;

        const updateParallax = () => {
            if (window.innerWidth < 992) {
                if (leftEl)  leftEl.style.transform = '';
                if (rightEl) rightEl.style.transform = '';
                return;
            }
            const rect     = module.getBoundingClientRect();
            const center   = rect.top + rect.height / 2 - window.innerHeight / 2;
            const maxDist  = window.innerHeight * 0.6;
            const progress = Math.min(1, Math.max(-1, center / maxDist));
            const offset   = 60 * progress;

            if (leftEl)  leftEl.style.transform  = `translateY(${offset}px)`;
            if (rightEl) rightEl.style.transform = `translateY(${-offset}px)`;
        };

        window.addEventListener('scroll', updateParallax, { passive: true });
        updateParallax();
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * expandingCards
    // *
    // *

    const ecTracks = document.querySelectorAll('.js-ec-track');

    ecTracks.forEach((track) => {
        const ecCards = Array.from(track.querySelectorAll('.js-ec-card'));
        if (!ecCards.length) return;

        const ecContainer = track.closest('.expandingCards');
        const ecPrev = ecContainer ? ecContainer.querySelector('.js-ec-prev') : null;
        const ecNext = ecContainer ? ecContainer.querySelector('.js-ec-next') : null;
        const ecTotal = ecCards.length;
        let ecCurrent = 0;

        // pagination dots
        const ecPagination = ecContainer ? ecContainer.querySelector('.js-ec-pagination') : null;
        if (ecPagination) {
            ecCards.forEach((_, i) => {
                const dot = document.createElement('button');
                dot.className = 'expandingCards__dot' + (i === 0 ? ' expandingCards__dot--active' : '');
                dot.setAttribute('aria-label', `Karte ${i + 1}`);
                dot.addEventListener('click', () => ecActivate(i));
                ecPagination.appendChild(dot);
            });
        }

        const ecActivate = (index) => {
            ecCards[ecCurrent].classList.remove('expandingCards__card--active');
            ecCurrent = ((index % ecTotal) + ecTotal) % ecTotal;
            ecCards[ecCurrent].classList.add('expandingCards__card--active');
            if (ecPagination) {
                ecPagination.querySelectorAll('.expandingCards__dot').forEach((dot, i) => {
                    dot.classList.toggle('expandingCards__dot--active', i === ecCurrent);
                });
            }
        };

        if (ecPrev) ecPrev.addEventListener('click', () => ecActivate(ecCurrent - 1));
        if (ecNext) ecNext.addEventListener('click', () => ecActivate(ecCurrent + 1));

        ecCards.forEach((card) => {
            card.addEventListener('click', () => ecActivate(Number(card.dataset.index)));
            const cardArrow = card.querySelector('.js-ec-card-arrow');
            if (cardArrow) {
                cardArrow.addEventListener('click', (e) => {
                    e.stopPropagation();
                    ecActivate(Number(card.dataset.index));
                });
            }
        });

        // touch/swipe support
        let ecTouchStartX = 0;
        track.addEventListener('touchstart', (e) => { ecTouchStartX = e.touches[0].clientX; }, { passive: true });
        track.addEventListener('touchend', (e) => {
            const dx = e.changedTouches[0].clientX - ecTouchStartX;
            if (Math.abs(dx) > 45) ecActivate(ecCurrent + (dx < 0 ? 1 : -1));
        });
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * keyFacts count-up
    // *
    // *

    const countUpEls = document.querySelectorAll('.js-kf-count');

    if (countUpEls.length) {
        const runCountUp = (el) => {
            const target = parseFloat(el.dataset.target);
            const suffix = el.dataset.suffix || '';
            const duration = 1500;
            const startTime = performance.now();

            const tick = (now) => {
                const progress = Math.min((now - startTime) / duration, 1);
                const eased = 1 - Math.pow(1 - progress, 3);
                el.textContent = Math.round(target * eased) + suffix;
                if (progress < 1) requestAnimationFrame(tick);
            };

            requestAnimationFrame(tick);
        };

        const countObserver = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    runCountUp(entry.target);
                    obs.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });

        countUpEls.forEach((el) => countObserver.observe(el));
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * mobile navigation
    // *
    // *

    const navPanel = document.querySelector('.js-nav-panel');
    const navOpenBtn = document.querySelector('.js-nav-open');
    const navCloseBtn = document.querySelector('.js-nav-close');
    const navBackdrop = document.querySelector('.js-nav-backdrop');

    if (navPanel !== null && navOpenBtn !== null) {

        function openNav() {
            navPanel.classList.add('is-open');
            navPanel.setAttribute('aria-hidden', 'false');
            navOpenBtn.setAttribute('aria-expanded', 'true');
            if (navBackdrop !== null) navBackdrop.classList.add('is-visible');
            document.body.style.overflow = 'hidden';
            // freeze panel at its collapsed height so opening a submenu scrolls
            // the navigation internally instead of growing the overlay
            navPanel.style.height = navPanel.offsetHeight + 'px';
        }

        function closeNav() {
            navPanel.classList.remove('is-open');
            navPanel.setAttribute('aria-hidden', 'true');
            navOpenBtn.setAttribute('aria-expanded', 'false');
            if (navBackdrop !== null) navBackdrop.classList.remove('is-visible');
            document.body.style.overflow = '';
            navPanel.style.height = '';
        }

        navOpenBtn.addEventListener('click', openNav);
        if (navCloseBtn !== null) navCloseBtn.addEventListener('click', closeNav);
        if (navBackdrop !== null) navBackdrop.addEventListener('click', closeNav);

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closeNav();
            }
        });
    }

    // mobile submenu toggles
    const navDropdownToggles = document.querySelectorAll('.js-nav-dropdown');

    navDropdownToggles.forEach(function (toggle) {
        const submenu = toggle.closest('.header__mobileDropdown').querySelector('.js-nav-submenu');
        if (submenu === null) return;

        toggle.addEventListener('click', function () {
            const isOpen = submenu.classList.toggle('is-open');
            toggle.classList.toggle('is-open', isOpen);
            toggle.setAttribute('aria-expanded', String(isOpen));
        });
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * signet assemble replay
    // * re-runs the logo animation when the user returns to the top
    // *

    const signet = document.querySelector('.js-signet');

    if (signet !== null && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const signetPaths = signet.querySelectorAll('path');
        let signetArmed = false;
        let signetBottomPlayed = false;

        function replaySignet() {
            signetPaths.forEach(function (path) { path.style.animation = 'none'; });
            void signet.offsetWidth;
            signetPaths.forEach(function (path) { path.style.animation = ''; });
        }

        document.addEventListener('scroll', function () {
            const atBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 10;

            // arm the top replay only after some real scrolling
            if (window.scrollY > 300) signetArmed = true;

            // top replay
            if (window.scrollY <= 0 && signetArmed) {
                signetArmed = false;
                replaySignet();
            }

            // bottom replay
            if (atBottom && !signetBottomPlayed) {
                signetBottomPlayed = true;
                replaySignet();
            }

            // re-arm bottom replay once user has scrolled away from the bottom
            if (!atBottom && window.scrollY + window.innerHeight < document.documentElement.scrollHeight - 200) {
                signetBottomPlayed = false;
            }
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollTo
    // *
    // *

    const anchors = document.querySelectorAll(".js-scrollTo");

    for (const anchor of anchors) {
        anchor.addEventListener("click", clickHandler);
    }

    function clickHandler(e) {
        e.preventDefault();

        let href = this.getAttribute("href").split("#");
        let newAnchor = "#my" + href[1]
        let offsetTop = document.querySelector(newAnchor).offsetTop;

        scroll({
            top: offsetTop,
            behavior: "smooth"
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hash link jump to content
    // *
    // *

    window.addEventListener('load', function () {
        let getHash = window.location.hash;
        let elementExists = document.getElementById("my" + getHash.slice(1));

        if (getHash !== null && elementExists !== null) {
            let name = "#my" + getHash.slice(1);
            let offsetTop = document.querySelector(name).offsetTop;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }

    }, false);



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollToTop
    // *
    // *

    const scrolltotop = document.querySelector(".js-scrolltop");

    if (scrolltotop !== null) {
        // show and hide scrollToTop btn on scroll
        document.addEventListener('scroll', function (e) {
            if (window.scrollY > 300) {
                scrolltotop.classList.add("show");
            } else {
                scrolltotop.classList.remove("show");
            }
        });

        // onclick scroll to top
        scrolltotop.onclick = function (e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }


    }



    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * anchor nav scrollTo
    // *
    // *

    // get browser width
    let browserWidth = window.innerWidth;
    let anchorBox = document.querySelector('.js-anchor-nav');
    let anchorBoxSticky = document.querySelector('.js-anchor-sticky');

    // check if anchor modul is set to sticky
    if (anchorBoxSticky !== null) {
        window.addEventListener('scroll', function (e) {
            // get pos from anchorbox
            let pos = Math.round(anchorBox.getBoundingClientRect().y);

            if (pos <= 0) {
                anchorBox.classList.add("stick");
            } else {
                anchorBox.classList.remove("stick");
            }
        });
    }

    // check if anchor modul is set
    if (anchorBox !== null) {
        // needed for sticky anchor to calculate offsetTop
        anchorBoxHeight = anchorBox.offsetHeight;

        if (browserWidth > 1280) {
            anchorBoxHeight = anchorBoxHeight;
        } else {
            anchorBoxHeight = 0;
        }

        const anchors = document.querySelectorAll(".js-scrollTo");

        for (const anchor of anchors) {
            anchor.addEventListener("click", clickHandler);
        }

        function clickHandler(e) {
            e.preventDefault();

            let href = this.getAttribute("href").split("#");
            let newAnchor = "#my" + href[1]
            let offsetTop = document.querySelector(newAnchor).offsetTop - anchorBoxHeight;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * modal window
    // *
    // *

    let modalWindow = document.querySelector(".js-modal");
    let modalOpen = document.querySelector(".js-modal-btn-open");
    let modalClose = document.querySelector(".js-modal-btn-close");

    /* onclick show modal window */
    if (modalOpen !== null) {
        modalOpen.onclick = function () {
            if (typeof modalWindow.showModal === "function") {
                modalWindow.showModal();
            } else {
                modalWindow.style.display = "block";
            }
            modalClose.focus();
        }
    }

    /* close modal window */
    if (modalClose !== null) {
        modalClose.onclick = function () {
            if (typeof modalWindow.close === "function") {
                modalWindow.close();
            } else {
                modalWindow.style.display = "none";
            }
        }
    }

    /* clicks anywhere outside close modal window */
    window.onclick = function (event) {
        if (event.target == modalWindow) {
            if (typeof modalWindow.close === "function") {
                modalWindow.close();
            } else {
                modalWindow.style.display = "none";
            }
        }
    }




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion open every tab
    // *
    // *

    const title = document.querySelectorAll(".js-accordion-title");

    if (title !== null) {
        for (var i = 0; i < title.length; i++) {
            title[i].onclick = function (e) {
                this.classList.toggle("open");
                this.parentElement.nextElementSibling.classList.toggle("open");

                let expanded = this.getAttribute('aria-expanded');

                if (expanded == 'false') {
                    this.setAttribute('aria-expanded', 'true')
                } else {
                    this.setAttribute('aria-expanded', 'false')
                }
            }
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * open external links in new tab
    // *
    // *

    function externalLinks() {
        for (let links = document.getElementsByTagName("a"), number = 0; number < links.length; number++) {
            let currentLink = links[number];

            // check if link has same hostname. if not add target blank.
            currentLink.getAttribute("href") && currentLink.hostname !== location.hostname && (currentLink.target = "_blank")
        }
    };

    externalLinks();




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * native parallax replacement
    // *
    // *

    const initParallax = () => {
        const parallaxImages = document.querySelectorAll('.js-parallax');
        if (parallaxImages.length === 0) return;

        const observerOptions = {
            threshold: 0,
            rootMargin: "0px"
        };

        const parallaxObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.dataset.visible = "true";
                } else {
                    entry.target.dataset.visible = "false";
                }
            });
        }, observerOptions);

        parallaxImages.forEach(img => {
            parallaxObserver.observe(img);
            // set initial scale to have some buffer for moving
            img.style.transform = "scale(1.2) translateY(0px)";
        });

        const updateParallax = () => {
            parallaxImages.forEach(img => {
                if (img.dataset.visible === "true") {
                    const rect = img.getBoundingClientRect();
                    const windowHeight = window.innerHeight;
                    const elementHeight = rect.height;
                    const elementCenter = rect.top + elementHeight / 2;
                    const viewportCenter = windowHeight / 2;

                    // calculate distance from center of viewport (-1 to 1)
                    const distance = (elementCenter - viewportCenter) / (windowHeight / 2 + elementHeight / 2);
                    const movement = distance * 50; // shift by 50px max

                    img.style.transform = `scale(1.2) translateY(${movement}px)`;
                }
            });
            requestAnimationFrame(updateParallax);
        };

        requestAnimationFrame(updateParallax);
    };

    initParallax();



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * native aos replacement (Intersection Observer)
    // *
    // *

    const aosElements = document.querySelectorAll('[data-aos]');

    const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
    };

    const aosObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('aos-animate');
                if (entry.target.getAttribute('data-aos-once') !== 'false') {
                    observer.unobserve(entry.target);
                }
            } else {
                if (entry.target.getAttribute('data-aos-once') === 'false') {
                    entry.target.classList.remove('aos-animate');
                }
            }
        });
    }, observerOptions);

    aosElements.forEach(element => {
        aosObserver.observe(element);
    });

    // * video teaser — supports multiple instances via DOM traversal
    document.querySelectorAll('.js-video-play').forEach(function (btn) {
        var section  = btn.closest('.videoTeaser');
        var dialog   = section.querySelector('.videoTeaser__dialog');
        var closeBtn = dialog.querySelector('.videoTeaser__dialogClose');
        var videoEl  = dialog.querySelector('.js-video-iframe, .js-video-native');
        var isNative = videoEl && videoEl.tagName === 'VIDEO';

        // focus trap
        var focusable = dialog.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])');
        var first = focusable[0];
        var last  = focusable[focusable.length - 1];
        dialog.addEventListener('keydown', function (e) {
            if (e.key !== 'Tab') return;
            if (e.shiftKey) {
                if (document.activeElement === first) { e.preventDefault(); last.focus(); }
            } else {
                if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
            }
        });

        function openVideo() {
            videoEl.src = videoEl.getAttribute('data-src');
            dialog.showModal();
            if (isNative) videoEl.play();
            closeBtn.focus();
        }

        function closeVideo() {
            if (isNative) { videoEl.pause(); videoEl.load(); }
            videoEl.removeAttribute('src');
            dialog.close();
            btn.focus();
        }

        btn.addEventListener('click', openVideo);
        closeBtn.addEventListener('click', closeVideo);
        dialog.addEventListener('click', function (e) {
            if (e.target === dialog) closeVideo();
        });
        dialog.addEventListener('close', function () {
            if (isNative) { videoEl.pause(); videoEl.load(); }
            videoEl.removeAttribute('src');
            btn.focus();
        });
    });

});
